
import { Breadcrumb } from 'antd';
import { ReactElement } from 'react';
import { HomeFilled } from '@ant-design/icons';
import './PageContentHeader.less';

interface Props {
    breadcrumb?: { data?: { text: string | JSX.Element, path?: string }[] };
    content?: { title?: string, additionalElement?: ReactElement };
}

export const defaultBreadCrumb = [{
    text: <HomeFilled />,
    path: "/",
}]

/**
 * @param breadcrumb ex: { data: [ ...defaultBreadCrumb ] }
 * @param content ex: { title: 'Admin' }
 */
const PageContentHeader = ({ breadcrumb, content }: Props) => {
    const renderBreadCrumb = () => {
        return <Breadcrumb className="breadcrumb">
            {
                breadcrumb?.data?.map((val: any) => {
                    return <Breadcrumb.Item key={val.text}>
                        {val.path ? <a href={val.path}>{val.text}</a> : val.text}
                    </Breadcrumb.Item>;
                })
            }
        </Breadcrumb>;
    }

    const renderRequest = () => {
        return <div className="content-header">
            {content?.additionalElement}
            <h1>{content?.title}</h1>
        </div>;
    }

    return <>
        {!!breadcrumb && renderBreadCrumb()}
        {!!content && renderRequest()}
    </>;
}

export default PageContentHeader;